/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlBulkReportAssetsItem
 */
export interface ControlBulkReportAssetsItem {
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsItem
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsItem
     */
    asset_id: string;
}

/**
 * Check if a given object implements the ControlBulkReportAssetsItem interface.
 */
export function instanceOfControlBulkReportAssetsItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "asset_id" in value;

    return isInstance;
}

export function ControlBulkReportAssetsItemFromJSON(json: any): ControlBulkReportAssetsItem {
    return ControlBulkReportAssetsItemFromJSONTyped(json, false);
}

export function ControlBulkReportAssetsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBulkReportAssetsItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': json['entity_id'],
        'asset_id': json['asset_id'],
    };
}

export function ControlBulkReportAssetsItemToJSON(value?: ControlBulkReportAssetsItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'asset_id': value.asset_id,
    };
}

